import React from 'react';
import Icon from '../../common/Icons';
import { buildPartnerListSecondaryLine, getPartnerTypePillProps } from './carePartnerListDisplay';

export default function CarePartnerListItem({ item, isEditing, copy, onOpenMenu }) {
  const secondary = buildPartnerListSecondaryLine(item);
  const typePill = getPartnerTypePillProps(item.partner_type);
  const statusLabel = item.is_active ? copy.STATUS_ACTIVE : copy.STATUS_INACTIVE;

  return (
    <li
      className={[
        'hd-partner-list__item',
        !item.is_active ? 'is-inactive' : '',
        isEditing ? 'is-editing' : ''
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <span
        className={`hd-partner-list__dot${item.is_active ? ' is-active' : ' is-inactive'}`}
        title={statusLabel}
        aria-label={statusLabel}
      />
      <div className="hd-partner-list__content">
        <span className="hd-partner-list__title">{item.name}</span>
        <span className={typePill.className}>{typePill.label}</span>
        {secondary ? (
          <>
            <span className="hd-partner-list__sep" aria-hidden>
              ·
            </span>
            <span className="hd-partner-list__sub" title={secondary}>
              {secondary}
            </span>
          </>
        ) : null}
      </div>
      <button
        type="button"
        className="hd-partner-list__menu hd-exam-actions-menu__toggle"
        onClick={onOpenMenu}
        aria-label={`Actions pour ${item.name}`}
        title="Actions"
      >
        <Icon name="ellipsis-vertical" size={17} />
      </button>
    </li>
  );
}
